export const SELECT_SUBCATEGORY = 'SELECT_SUBCATEGORY'
// export const SELECT_VIEWSTYLE = 'SELECT_VIEWSTYLE'